import {Component} from '@angular/core';
import {AlertController, Platform} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import * as moment from 'moment';
import { zip} from 'rxjs';

import 'cordova-plugin-purchase';

import {UserContent} from 'app/profile/model/model';
import {UserService} from 'app/profile/services/user.service';
import {getTranslation} from 'shared/helpers/get-translation';
import {NavService} from 'shared/nav/nav.service';
import {ContentService} from '../../services/content.service';
import { DefaultPage } from 'app/menu/components/default-page/default-page';

const LABEL_FORMAT: string = 'dddd, DD.MM.YYYY';

@Component({
  selector: 'content-purchase-page',
  templateUrl: 'content-purchase-page.html',
  styleUrls: ['content-purchase-page.scss'],
})
export class ContentPurchasePage extends DefaultPage {

  public userContent: UserContent;
  product: CdvPurchase.Product

  private inCharge = false;

  private store?: CdvPurchase.Store;

  constructor(
    private navService: NavService,
    private translateService: TranslateService,
    private contentService: ContentService,
    private userService: UserService,
    private alertCtrl: AlertController,
    private platform: Platform,
  ) {
    super(navService);
    this.userContent = <UserContent> this.navService.get('userContent');
    this.product = <CdvPurchase.Product> this.navService.get('product');
    this.platform.ready().then(() => {
      if (this.platform.is('capacitor')) {
        console.log("YYY1 in capacitor")
        this.store = CdvPurchase.store;
        this.store.verbosity = CdvPurchase.LogLevel.DEBUG;

        this.store.when()
        .approved((p: CdvPurchase.Transaction) => {
          if (!this.inCharge) {
            return;
          }
          if ( p.purchaseId === 'de.leada.app') { // ios
            return;
          }
          // Handle the product deliverable
          console.log("YYY1 approved_: "+JSON.stringify(p));
          if (this.userContent.contentFull.productId == p.products[0]?.id) {
            console.log("YYY1 call server.purchase: "+p.products[0]?.id);
            return this.contentService.purchase(this.userContent, p.products[0]?.id)
              .subscribe((ok) => {
                if (ok) {
                  console.log("YYY1 call verify: "+p.products[0]?.id);
                  return p.verify();
                }
                else {
                  this.showErrorAlert('[_1]');
                  return;
                }
              });
          }
        })
        .verified((p: CdvPurchase.VerifiedReceipt) => {
          if (!this.inCharge) {
            return;
          }
          if ( p.id === 'de.leada.app') { // ios
            return;
          }
          console.log("YYY1 verified_: "+p.id);
          if (this.userContent.contentFull.productId == p.sourceReceipt?.transactions[0]?.products[0]?.id) {
            console.log("YYY1 call finish: "+p.id);
            p.finish();
          }
        })
        // .owned((p: IAPProduct) => {
        //   console.log("YYY1 owned_: "+p.id);
        // })
        .finished((p: CdvPurchase.Transaction) => {
          if (!this.inCharge) {
            return;
          }
          if ( p.purchaseId === 'de.leada.app') { // ios
            return;
          }
          console.log("YYY1 finished_: "+p.products[0]?.id);
          if (this.userContent.contentFull.productId == p.products[0]?.id) {
            this.showPurchasedAlert();
          }
        })

        this.store.update();
      }

    });

  }

  private ionViewWillEnter(): void {
    this.inCharge = true;
  }

  private ionViewWillLeave(): void {
    this.inCharge = false;
  }


  public getLocalizedContentText(text: Dictionary<string>): string {
    return getTranslation(text, this.translateService);
  }

  public formateDate(date: Date): string {
    return moment(date).format('DD.MM.YYYY');
  }

  public getPrice(userContent: UserContent): string {
    return this.product.pricing.price + ' ' + this.product.pricing.currency;
  }

  public purchase(): void {
    // für Tests ohne store
/*    this.contentService.purchase(this.userContent, this.product.id)
      .subscribe((ok: boolean) => {
        if (ok) {
          this.contentService.getContent(this.userContent)
            .subscribe((userContentTemp: UserContent) => {
              if ( userContentTemp !== null ) {
                console.log("XXX %o", userContentTemp)
                this.userContent = userContentTemp;
                if (this.userContent.state == 0) {
                  this.showPurchasedAlert();
                }
                else {
                  this.showErrorAlert('[_10]');
                }
              }
              else {
                this.showErrorAlert('[_11]');
              }
            })
        }
        else {
          this.showErrorAlert('[_1]');
        }
      });*/

    // mit store
    console.log("YYY call order: "+this.product.id);
    this.store.order(this.product.getOffer()).then(p => {
      console.log("YYY1 order")
    }, e => {
      this.showErrorAlert(`YYY1 Failed to purchase: ${e}`);
    });
  }

  public leave():void  {
    this.navService.pop();
  }

  private showPurchasedAlert(): void {

    this.translateService.get([
      'CONTENT.PURCHASE_ALERT.TITLE',
      'CONTENT.PURCHASE_ALERT.MESSAGE',
      'COMMON.NO',
      'COMMON.YES',
    ]).subscribe(async(translations) => {
      const titleLabel: string = translations['CONTENT.PURCHASE_ALERT.TITLE'];
      const message: string = translations['CONTENT.PURCHASE_ALERT.MESSAGE'];
      const noLabel: string = translations['COMMON.NO'];
      const yesLabel: string = translations['COMMON.YES'];

      const alert: HTMLIonAlertElement = await this.alertCtrl.create({
        cssClass: 'first-impulse-alert-class',
        header: titleLabel,
        message: message,
        buttons: [
          {
            text: noLabel,
            role: 'cancel',
            handler: (): void => {
              this.leave();
            },
          },
          {
            text: yesLabel,
            handler: (): void => {
              this.start();
            },
          },
        ],
      });
      alert.present();
    });
  }

  private start(): void {
    this.contentService.start(this.userContent)
      .subscribe(() => {
        // recalc
        this.contentService.calculateNewContents()
          .subscribe((cnt) => {
            this.userService.setNewContentCount(cnt);
            this.load();
          });
      });
  }

  private load(): void {
    this.contentService.getContent(this.userContent)
      .subscribe((userContentTemp: UserContent) => {
          if (userContentTemp !== null ) {
            const firstImpulseDate: moment.Moment = this.getFirstImpulseDate(userContentTemp);
            if (firstImpulseDate.isAfter(moment(), 'days')) {
              this.showFirstImpulseInfo(firstImpulseDate.toDate());
            }
            else {
              this.leave();
            }
          }
      });
  }

  private getFirstImpulseDate(startedContent: UserContent): moment.Moment {
    let minDay: number = 999;
    startedContent.contentFull.items.forEach((item) => {
      if (item.day < minDay) {
        minDay = item.day;
      }
    });
    return moment(startedContent.baseDate).add(minDay, 'days');
  }

  private showFirstImpulseInfo(startdate: Date): void {

    this.translateService.get([
      'CONTENT.FIRST_IMPULSE.TITLE',
      'CONTENT.FIRST_IMPULSE.MESSAGE',
      'COMMON.OK',
    ],
    {datum: this.formateDate(startdate)},
    ).subscribe(async(translations) => {
      const titleLabel: string = translations['CONTENT.FIRST_IMPULSE.TITLE'];
      const message: string = translations['CONTENT.FIRST_IMPULSE.MESSAGE'];
      const okLabel: string = translations['COMMON.OK'];

      const alert: HTMLIonAlertElement = await this.alertCtrl.create({
        cssClass: 'first-impulse-alert-class',
        header: titleLabel,
        message: message,
        buttons: [
          {
            text: okLabel,
            handler: (): void => {
              this.leave();
            },
          },
        ],
      });
      alert.present();
    });
  }

  private showErrorAlert(s: string): void {
    zip(
      this.translateService.get('COMMON.ERROR'),
      this.translateService.get('COMMON.OK'),
      this.translateService.get('CONTENT.COULD_NOT_PURCHASE'),
    ).subscribe(async(translations) => {
      const alert = await this.alertCtrl.create({
        subHeader: translations[0],
        buttons: [translations[1]],
        // tslint:disable-next-line:no-magic-numbers
        message: translations[2]+' '+s,
      });
      alert.present();
    });
  }
}
